module.exports = __webpack_public_path__ + "static/media/sbt.38479ce8.svg";